import { render, staticRenderFns } from "./VFairInvite.vue?vue&type=template&id=1ea57e44&scoped=true"
import script from "./VFairInvite.vue?vue&type=script&lang=ts"
export * from "./VFairInvite.vue?vue&type=script&lang=ts"
import style0 from "./VFairInvite.vue?vue&type=style&index=0&id=1ea57e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea57e44",
  null
  
)

export default component.exports